export const flags = {
    actionButtons: {
        download: true,
    },
};
